import { Box, Button, Chip, Divider, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
import { useAppDispatch, useAppSelector } from "../../../Hooks";
import { getUserInfo, getUserRequestMessage } from "../../../store/user-process/selector";
import { userIsRole } from "../../../utils/user-is-role";
import { Status, UserRole } from "../../../enums/enum";
import { IUserInfo } from "../../../types/user-info/user-info";
import { OperatorTakeOnJob, UpdateStatusUserRequestOperator } from "../../../services/api-actions/personal-user-request-action";
import { brand } from "../../../theme";

type MessagesPaneHeaderProps = {
  thema: string;
  userInfo: IUserInfo;
  chatId: string | undefined;
};

function statusColor(id: number | undefined) {
  if (id === Status.Success) return "success" as const;
  if (id === Status.Cansel) return "error" as const;
  if (id === Status.InWork) return "warning" as const;
  return "info" as const;
}

function Meta({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <Box>
      <Typography sx={{ fontSize: 12, color: brand.muted }}>{label}</Typography>
      <Typography sx={{ fontSize: 14, fontWeight: 600 }}>{value}</Typography>
    </Box>
  );
}

export default function MessagesPaneHeader(props: MessagesPaneHeaderProps) {
  const dispatch = useAppDispatch();
  const userMessage = useAppSelector(getUserRequestMessage);
  const userInfo = useAppSelector(getUserInfo);
  const request = userMessage != undefined && userMessage != null ? userMessage[0]?.personalUserRequest : undefined;
  const statusId = request?.status?.id;
  const isStaff = userIsRole(userInfo, UserRole.Operator) || userIsRole(userInfo, UserRole.OperatorAdmin) || userIsRole(userInfo, UserRole.Admin);
  const closed = statusId === Status.Cansel || statusId === Status.Success;
  const goBack = () => {
    window.history.back();
    window.close();
  };

  return (
    <Box sx={{ borderBottom: `1px solid ${brand.line}`, bgcolor: "#fff", borderTopLeftRadius: 16, borderTopRightRadius: 16 }}>
      <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} gap={2} sx={{ p: 2 }}>
        <Button onClick={goBack} startIcon={<ArrowBackIcon />} sx={{ color: brand.muted, flexShrink: 0 }}>
          Назад
        </Button>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Stack direction="row" gap={1} alignItems="center" flexWrap="wrap">
            <Typography variant="h6" sx={{ lineHeight: 1.3 }}>
              {props.thema}
            </Typography>
            {request?.status?.status && <Chip size="small" color={statusColor(statusId)} label={request.status.status} />}
          </Stack>
          <Stack direction="row" gap={3} flexWrap="wrap" sx={{ mt: 1 }}>
            <Meta label="Лицевой счёт" value={!request?.lic || request.lic === "undefined" ? "не привязан" : request.lic} />
            {isStaff && userMessage?.[0]?.user?.email && <Meta label="Почта клиента" value={userMessage[0].user.email} />}
          </Stack>
        </Box>
      </Stack>

      {(userIsRole(props.userInfo, UserRole.Admin) || userIsRole(props.userInfo, UserRole.Operator)) && (
        <>
          <Divider />
          <Stack direction="row" gap={1} flexWrap="wrap" sx={{ px: 2, py: 1.5, bgcolor: brand.background }}>
            {!closed && (
              <Button
                variant="contained"
                color="success"
                size="small"
                startIcon={<CheckCircleOutlineIcon />}
                onClick={() => {
                  if (props.chatId != undefined && props.chatId != null) {
                    dispatch(UpdateStatusUserRequestOperator({ statusId: Status.Success.toString(), requestId: props.chatId })).then(() => {
                      window.location.reload();
                    });
                  }
                }}
              >
                Выполнено
              </Button>
            )}
            {!closed && (
              <Button
                variant="outlined"
                color="error"
                size="small"
                startIcon={<CancelOutlinedIcon />}
                onClick={() => {
                  if (props.chatId != undefined && props.chatId != null) {
                    dispatch(UpdateStatusUserRequestOperator({ statusId: Status.Cansel.toString(), requestId: props.chatId })).then(() => {
                      window.location.reload();
                    });
                  }
                }}
              >
                Отменить
              </Button>
            )}
            {statusId != Status.InWork && statusId != Status.Create && (
              <Button
                variant="contained"
                size="small"
                startIcon={<AssignmentTurnedInOutlinedIcon />}
                onClick={() => {
                  if (props.chatId != undefined && props.chatId != null)
                    dispatch(OperatorTakeOnJob({ requestId: props.chatId })).then(() => {
                      window.location.reload();
                    });
                }}
              >
                Взять заявку в работу
              </Button>
            )}
          </Stack>
        </>
      )}
    </Box>
  );
}
